/**
 * The full set of start-cased MLA-validated fields
 *
 * Which of these is actually validated depends on the sale sub-type (see selectors/mls.ts)
 */
export const MLAValidatedFields = {
  AGE: "Age Id",
  BREED: "Breed Id",
  EST_LIVE_WEIGHT: "Estimated Average Mass Grams",
  EST_CARCASS_WEIGHT: "Est Carcass Weight",
  FRAME_STRUCTURE: "Frame Structure",
  JOINED_END: "Joined End",
  JOINED_START: "Joined Start",
  PRODUCT: "Product Id",
  SEX: "Sex Id",
  SHEARING_STATUS: "Shearing Status",
  SHEARING_DATE: "Shearing Date",
};
